import 'whatwg-fetch';
import _ from 'lodash';

const JSON_HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};

function method(name) {
	return function(url, options={}) {
		const opts = _.clone(options);
		if (typeof opts.body !== 'string') {
			opts.body = JSON.stringify(opts.body);
		}
		_.defaults(opts, {
			method: name,
			headers: JSON_HEADERS
		});
		return api(url, opts);
	};
}

function api(url, options={}) {
	if (!url.match(/^\W|(https?:)/)) {
		url = '/n/api/' + url;
	}
	_.defaults(options, {credentials: 'same-origin'});
	return fetch(url, options)
		.catch(() => Promise.reject(new Error('Network Error')))
		.then(function(resp) {
			if (options.method === 'HEAD') {
				// For HEAD requests, just send along the status.
				return Promise.resolve(resp.status);
			}
			if (resp.status >= 200 && resp.status < 300) {
				return Promise.resolve(resp.status === 204 ? null : resp.json());

			} else if (resp.headers.get('content-type') === 'application/json') {
				return resp.json().then(function(json) {
					return Promise.reject(new Error(json.message || resp.statusText));
				});

			} else {
				return Promise.reject(new Error(resp.statusText));
			}
		});
}

api.get = method('GET');
api.post = method('POST');
api.put = method('PUT');
api.patch = method('PATCH');
api.delete = method('DELETE');
api.head = method('HEAD');

export default api;



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/api/index.js
 **/